import BaseTabButtons from "@PegasusCore/pegasus-one-tab-buttons/src/script";

class TabButtons extends BaseTabButtons {
    constructor() {
        super();
        this.timer = null;
        this.isTimerActive = false;
        this.timerInterval = 9000;
        this.shouldRealign = false;
        this.initialPosition = null;
        this.isCoverageMapTabs = false;
        this.coverageMapTechToTab = {
            '2G': '2g-coverage',
            '3G': '3g-coverage',
            '4G': '4g-coverage',
            '5G': '5g-coverage',
            'LTE-M': 'lte-m-coverage',
            'NB_IOT': 'nb-iot-coverage',
        };
        this.onCoverageMapTechChange = this.handleCoverageMapTechChange.bind(this);
    }

    init() {
        super.init();
        this.initialPosition = this.$el.getBoundingClientRect().top + window.pageYOffset;
        this.isCoverageMapTabs = !!this.$el.closest('.Tab__Coverage_Map');
        if (this.isCoverageMapTabs) {
            window.addEventListener('coveragemap:techchange', this.onCoverageMapTechChange);
        }
    }

    initTabButtons(firstTargetID, autoSwitch = false, realignContent = false) {
        super.initTabButtons(firstTargetID);
        this.isTimerActive = autoSwitch;
        this.shouldRealign = realignContent;
        
        if (this.isTimerActive) {
            this.startTimer();
        }
    }

    startTimer() {
        this.stopTimer();
        this.timer = setInterval(() => {
            this.autoSwitchTab();
        }, this.timerInterval);
    }

    stopTimer() {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    }

    autoSwitchTab() {
        const currentIndex = this.tabButtons.indexOf(this.activeTab);
        const nextIndex = (currentIndex + 1) % this.tabButtons.length;
        const nextTab = this.tabButtons[nextIndex];
        
        this.showTab(nextTab);
    }

    scrollToElement() {
        const offset = 70;
        const scrollPosition = this.initialPosition - offset;

        window.scrollTo({
            top: scrollPosition,
            behavior: 'smooth'
        });
    }

    showTab(targetID) {
        super.showTab(targetID);
        
        if (this.isTimerActive) {
            this.stopTimer();
            this.startTimer();
        }
        
        if (this.shouldRealign) {
            setTimeout(() => {
                this.scrollToElement();
            }, 100);
        }
    }

    handleCoverageMapTechChange(event) {
        if (!this.isCoverageMapTabs) return;
        const tech = event?.detail?.tech;
        if (!tech) return;

        const targetTabID = this.coverageMapTechToTab[tech];
        if (!targetTabID || !this.tabButtons.includes(targetTabID) || this.activeTab === targetTabID) {
            return;
        }

        this.showTab(targetTabID);
    }

    destroy() {
        if (this.isCoverageMapTabs) {
            window.removeEventListener('coveragemap:techchange', this.onCoverageMapTechChange);
        }
        if (super.destroy) {
            super.destroy();
        }
    }
}

document.addEventListener("alpine:init", () => {
    Alpine.data("tabButtons", () => new TabButtons());
});
